import { legacyApiResourceUrl } from "@ploy-lib/core";
import { BasePlainResource, BaseCamelCasedResource } from "./BasePlainResource";
export var LoginStatusEnum;
(function (LoginStatusEnum) {
    LoginStatusEnum["NotSet"] = "NotSet";
    LoginStatusEnum["ChangePassword"] = "ChangePassword";
    LoginStatusEnum["SupplyMobile"] = "SupplyMobile";
    LoginStatusEnum["ChooseVendor"] = "ChooseVendor";
    LoginStatusEnum["AccountStatusOK"] = "AccountStatusOK";
    LoginStatusEnum["TwoFactorAuthValidation"] = "TwoFactorAuthValidation";
})(LoginStatusEnum || (LoginStatusEnum = {}));
export class LoginResource extends BasePlainResource {
    constructor() {
        super(...arguments);
        this.status = LoginStatusEnum.NotSet;
        this.isInternal = false;
        this.isDirectUser = false;
        this.browserDeprecation = {};
    }
    get isAuthenticated() {
        return this.status === LoginStatusEnum.AccountStatusOK;
    }
    pk() {
        return "Login";
    }
    static merge(first, second) {
        // Always overwrite
        return second;
    }
    static status() {
        return this.detail().extend({
            url: urlParams => `${this.urlRoot}/Login`
        });
    }
    static login() {
        return this.create().extend({
            url: urlParams => `${this.urlRoot}/Login`
        });
    }
    static tokenLogin() {
        const tokenEndpoint = this.create().extend({
            url: urlParams => `${this.urlRoot}/tokenLogin`
        });
        const statusEndpoint = this.status();
        // Cache as if it's a LoginResource.status() request
        // useResource(LoginResource.status(), {}) will then use this cached response instead
        return tokenEndpoint.extend({
            sideEffect: undefined,
            key: () => statusEndpoint.key({}),
            fetch: params => tokenEndpoint.fetch({}, params)
        });
    }
    static setVendor() {
        return this.login();
    }
    static setMobile() {
        return this.login();
    }
    static setPassword() {
        return this.login();
    }
    static logout() {
        return this.create().extend({
            url: () => `${this.urlRoot}/Logout`
        });
    }
    static selectVendor() {
        return this.create().extend({
            url: () => `${this.urlRoot}/SelectVendor`
        });
    }
}
LoginResource.urlRoot = legacyApiResourceUrl("Login");
export class TokenLoginResource extends BasePlainResource {
    constructor() {
        super(...arguments);
        this.status = LoginStatusEnum.NotSet;
        this.isInternal = false;
        this.isDirectUser = false;
        this.browserDeprecation = {};
    }
    get isAuthenticated() {
        return this.status === LoginStatusEnum.AccountStatusOK;
    }
    pk() {
        return "TokenLogin";
    }
    static merge(first, second) {
        // Always overwrite
        return second;
    }
    static tokenLogin() {
        const endpoint = this.create().extend({
            url: () => `${this.urlRoot}/tokenLogin`
        });
        return endpoint.extend({
            fetch: params => endpoint.fetch({}, params)
        });
    }
}
TokenLoginResource.urlRoot = legacyApiResourceUrl("Login");
export class PasswordResetResource extends BaseCamelCasedResource {
    static requestPasswordChange() {
        return this.create().extend({
            url: () => `${this.urlRoot}/RequestPasswordChange`
        });
    }
    static updatePassword() {
        return this.create().extend({
            url: () => `${this.urlRoot}/ChangePassword`
        });
    }
    static resetPassword() {
        return this.create().extend({
            url: () => `${this.urlRoot}/ResetPwd`
        });
    }
    pk() {
        return "ResetPwd";
    }
}
PasswordResetResource.urlRoot = legacyApiResourceUrl("Login");
export class LoginInfoResource extends BaseCamelCasedResource {
    pk() {
        return "GetLoginInfoMessage";
    }
}
LoginInfoResource.urlRoot = legacyApiResourceUrl("Login");
//# sourceMappingURL=LoginResource.js.map